import * as i0 from '@angular/core';
import { Directive, Input, NgModule } from '@angular/core';
import { Subscription, fromEvent } from 'rxjs';
import * as i1 from '@pv-frontend/pv-shared-services/telemetry-service';
import { CommonModule } from '@angular/common';

class ClickTrackDirective {
    constructor(host, telemetryService) {
        this.host = host;
        this.telemetryService = telemetryService;
        this.activeSubscriptions = new Subscription();
        this.trackedEventLabel = '';
        /**
         * Indicates whether the click should be tracked or not for a given element
         *
         * The default value is `false`
         */
        this.shouldTrackClick = false;
    }
    ngOnInit() {
        this.setupListeners();
    }
    ngOnChanges(changes) {
        if (changes.label) {
            this.trackedEventLabel = this.getElementLabel(changes.label.currentValue);
        }
    }
    ngOnDestroy() {
        this.clearListeners();
    }
    setupListeners() {
        this.clearListeners();
        this.activeSubscriptions = new Subscription();
        if (this.shouldTrackClick) {
            this.activeSubscriptions.add(fromEvent(this.host.nativeElement, 'click').subscribe(() => {
                this.telemetryService.trackEvent({
                    eventType: 'click',
                    label: this.getElementLabel(),
                });
            }));
        }
    }
    clearListeners() {
        this.activeSubscriptions.unsubscribe();
    }
    getElementLabel(overrideValue) {
        return (overrideValue ??
            this.trackedEventLabel ??
            this.host.nativeElement?.textContent ??
            '').trim();
    }
}
ClickTrackDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ClickTrackDirective, deps: [{ token: i0.ElementRef }, { token: i1.TelemetryImplService }], target: i0.ɵɵFactoryTarget.Directive });
ClickTrackDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.9", type: ClickTrackDirective, selector: "[pvClickTrack]", inputs: { shouldTrackClick: ["pvClickTrack", "shouldTrackClick"], label: ["pvTrackLabel", "label"] }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ClickTrackDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[pvClickTrack]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1.TelemetryImplService }]; }, propDecorators: { shouldTrackClick: [{
                type: Input,
                args: ['pvClickTrack']
            }], label: [{
                type: Input,
                args: ['pvTrackLabel']
            }] } });

class ClickTrackingModule {
}
ClickTrackingModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ClickTrackingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ClickTrackingModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: ClickTrackingModule, declarations: [ClickTrackDirective], imports: [CommonModule], exports: [ClickTrackDirective] });
ClickTrackingModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ClickTrackingModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ClickTrackingModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [ClickTrackDirective],
                    exports: [ClickTrackDirective],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ClickTrackDirective, ClickTrackingModule };
